import { apiCallWrapper } from "traveldesk-ui";
import LanguageModel from "../models/LanguageModel";
export default class LanguagesApiService {
    public static async getForInventory(dispatch: any) {
        return await apiCallWrapper<LanguageModel[]>(`/api/languages/inventory`, 'GET', dispatch)
    }
}